import React from 'react';
import { useWebNotificationContext } from '../../../contexts/WebNotificationContext';
import { useAuth } from '../../../contexts/AuthContext';
import { Bell, BellOff } from 'lucide-react';

const PushNotificationSettings = () => {
  const { user } = useAuth();
  const {
    pushSupported,
    pushEnabled,
    enablePushNotifications
  } = useWebNotificationContext();

  if (!pushSupported) {
    return (
      <div className="flex items-center justify-between py-2">
        <div className="flex items-center gap-3">
          <div className="flex rounded-full w-10 h-10 bg-yellow-100 items-center justify-center">
            <BellOff size={18} className="text-yellow-600" />
          </div>
          <span className="text-sm font-medium text-gray-600">Push notifications not supported</span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between py-2">
      <div className="flex items-center gap-3">
        <div className={`flex rounded-full w-10 h-10 items-center justify-center ${
          pushEnabled ? "bg-green-100" : "bg-gray-100"
        }`}>
          <Bell size={18} className={pushEnabled ? "text-green-600" : "text-gray-400"} />
        </div>
        <span className="text-sm font-medium text-gray-700">
          Push Notifications
        </span>
      </div>
      
      {pushEnabled ? (
        <span className="px-3 py-1.5 rounded text-xs font-medium bg-green-100 text-green-700">
          Enabled
        </span>
      ) : (
        <button
          onClick={enablePushNotifications}
          className="px-3 py-1.5 rounded text-xs font-medium bg-blue-600 text-white hover:bg-blue-700 transition"
        >
          Enable
        </button>
      )}
    </div>
  );
};

export default PushNotificationSettings;